import auth from '@/i18n/en/auth.json'
import pages from '@/i18n/en/pages.json'
import account from '@/i18n/en/account.json'
import error from '@/i18n/en/error.json'
import base from '@/i18n/en/base.json'
import validation from '@/i18n/en/validation.json'
import session from '@/i18n/en/session.json'
import date from '@/i18n/en/date.json'
import profile from '@/i18n/en/profile.json'
import avatar from '@/i18n/en/avatar.json'
import location from '@/i18n/en/location.json'
import nationality from '@/i18n/en/nationality.json'
import hobbies from '@/i18n/en/hobbies.json'
import languages from '@/i18n/en/languages.json'
import note from '@/i18n/en/note.json'
import marriage from '@/i18n/en/marriage.json'
import children_count from '@/i18n/en/children-count.json'
import drivers from '@/i18n/en/drivers.json'
import way_to_work from '@/i18n/en/way-to-work.json'
import file from '@/i18n/en/file.json'
import gender from '@/i18n/en/gender.json'
import candidate_invite from '@/i18n/en/candidate-invite.json'
import contacts from '@/i18n/en/contacts.json'
import education from '@/i18n/en/education.json'
import institution from '@/i18n/en/institution.json'
import skills from '@/i18n/en/skills.json'
import interview_profile from '@/i18n/en/interview-profile.json'
import interview_candidate from '@/i18n/en/interview-candidate.json'
import current_employment_status from '@/i18n/en/current-employment-status.json'
import work_notice_period from '@/i18n/en/work-notice-period.json'
import experience from '@/i18n/en/experience.json'
import education_degree from '@/i18n/en/education-degree.json'
import market from '@/i18n/en/market.json'
import residence_permit_germany from '@/i18n/en/residence-permit-germany.json'
import distance_unit from '@/i18n/en/distance-unit.json'
import company from '@/i18n/en/company.json'
import residence_permit from '@/i18n/en/residence-permit.json'
import candidate_dashboard from '@/i18n/en/candidate-dashboard.json'
import process from '@/i18n/en/process.json'
import calendar_event from '@/i18n/en/calendar-event.json'
import vacancy from '@/i18n/en/vacancy.json'
import benefits from '@/i18n/en/benefits.json'
import experience_level from '@/i18n/en/experience_level.json'
import experience_positions from '@/i18n/en/experience_positions.json'
import cookies from '@/i18n/en/cookies.json'
import employment from '@/i18n/en/employment.json'
import career_position from '@/i18n/en/career-position.json'
import travel from '@/i18n/en/travel.json'
import chat from '@/i18n/en/chat.json'
import pagination from '@/i18n/en/pagination.json'
import footer from '@/i18n/en/footer.json'
import social from '@/i18n/en/social.json'
import help from '@/i18n/en/help.json'

export default {
  validation,
  auth,
  pages,
  account,
  error,
  base,
  session,
  date,
  profile,
  avatar,
  location,
  nationality,
  hobbies,
  languages,
  note,
  marriage,
  children_count,
  drivers,
  way_to_work,
  file,
  candidate_invite,
  contacts,
  education,
  institution,
  interview_profile,
  interview_candidate,
  current_employment_status,
  work_notice_period,
  experience,
  education_degree,
  gender,
  company,
  residence_permit_germany,
  residence_permit,
  market,
  candidate_dashboard,
  skills,
  chat,
  process,
  calendar_event,
  vacancy,
  benefits,
  experience_level,
  experience_positions,
  employment,
  career_position,
  travel,
  distance_unit,
  cookies,
  pagination,
  social,
  help,
  ...footer
}
